import Raven from "raven-js";
import {config} from "../config/config";

if (config.sentry.dsn) {
    Raven.config(config.sentry.dsn).install()
}

export const logger = {
    enabled: !!config.sentry.dsn,
    captureException: e => {
        console.trace("captureException", e.stack, [e])
        Raven.captureException(e)
    },
    captureMessage: (msg, options) => {
        console.trace("captureMessage", msg, options)
        Raven.captureMessage(msg, options)
    },
}
